import { render, staticRenderFns } from "./TopPanel.vue?vue&type=template&id=381dd555"
import script from "./TopPanel.vue?vue&type=script&lang=ts"
export * from "./TopPanel.vue?vue&type=script&lang=ts"
import style0 from "./TopPanel.vue?vue&type=style&index=0&id=381dd555&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports